import { OffersVariationNameComponent } from './offers-variation-name.component';

import { runClientComponent } from '../../_common/client/client-component-runner';

runClientComponent({ offersVariationName: OffersVariationNameComponent });
